// extracted by mini-css-extract-plugin
export default {"cls1":"Rating-cls1__e7f1a1fce85348286270","cls2":"Rating-cls2___bcd97f9636f9b962ee7 Rating-cls1__e7f1a1fce85348286270"};